import {React,useState} from 'react'
import './Heading.css'
import MenuIcon from '@material-ui/icons/Menu';
import Nav_items from './Nav_items'
import Nav_icons from './Nav_icons'
import useDocumentTitle from '../Document'

    
    
    // return (
        const Heading = () => {
            useDocumentTitle('Home')
            //create a open state (true / false)
            const [ open, setOpen ] = useState(true);
        
            //a simple toggle function that switches between true/false
            const toggle = () => setOpen(!open)
            return (
               
                <div>
           
                   <nav class={`nav ${ open ? '' : 'collapse' }`}>
                <div class="nav-menu flex-row">
                    <div class="nav-brand">
                        <a href="/" class="text-gray" >NOOB-GEEKS</a>
                    </div>
                    <div class="toggle-collapse">
                    
                        <div class="toggle-icon" onClick={toggle} > 
                       
                            <MenuIcon/>
                        </div>
                    </div>
                 
                    <div>
                    
                      <Nav_items/>
                    
                    </div>
                   
                </div>
                
            </nav>
        
                </div>
            )
    //     <div>
    //        <nav class="nav">
    //     <div class="nav-menu flex-row">
    //         <div class="nav-brand">
    //             <a href="/" class="text-gray" >NOOB-GEEKS</a>
    //         </div>
    //         <div class="toggle-collapse">
    //             <div class="toggle-icon"> 
    //                 <MenuIcon/>
    //             </div>
    //         </div>
    //         <div>
    //           <Nav_items/>
            
    //         </div>
    //        <Nav_icons/>
    //     </div>
    // </nav>
   
    //     </div>
    // )
   
    
            }

export default Heading